import * as requestFromServer from "./GradeCoursesCrud";
import { callTypes, gradeCourseSlice } from "./GradeCoursesSlice";

const {actions} = gradeCourseSlice;

export const getGradeCourses = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getGradeCourses(queryParams)
    .then(response => {
      dispatch(actions.gradeCoursesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllGradeCourses = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllGradeCourses(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getCourses = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getCourses()
    .then(response => {
      dispatch(actions.coursesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getCourse = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewCourse()
    .then(response => {
      dispatch(actions.courseFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getCourse(id)
    .then(response => {
      dispatch(actions.courseFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveCourse = course => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveCourse(course)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteCourses = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteCourses(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanCoursesState = () => dispatch => {
  dispatch(actions.coursesStateCleaned());
}